export const SYNTHETIX_PERP_CONNECTOR = 'Synthetix-Perp-v1.4';
export const SYNTHETIX_PERP_LIMIT_CONNECTOR = 'Synthetix-Perp-Limit-Order-v1.1';
export const SYNTHETIX_PERP_ADVANCED_CONNECTOR = 'Synthetix-Advanced-Orders-v1';
export const MATCHA_CONNECTOR = 'Matcha-v1';
export const AAVE_CONNECTOR = 'Aave-v3-v1';
export const FLASH_POOL_CONNECTOR = 'Poly-Instapool-v1';
